import React, {useEffect, useRef, useState} from 'react'
import PropTypes from 'prop-types'

export default function CheckboxAccordion({children, showText, hideText, height = 170}) {
    const [isOpen, setIsOpen] = useState(false)
    const [accordionHeight, setAccordionHeight] = useState(height)
    const [buttonText, setButtonText] = useState(showText)
    const [renderButton, setRenderButton] = useState(true)
    const ref = useRef(null)

    useEffect(() => {
        if (ref.current.clientHeight <= height) {
            setRenderButton(false)
        }
    })

    const handleClick = () => {
        setIsOpen(!isOpen)

        if (isOpen) {
            setAccordionHeight(height)
            setButtonText(showText)
        } else {
            setAccordionHeight(ref.current.offsetHeight)
            setButtonText(hideText)
        }
    }

    return (
        <div>
            <div className={'checkbox-accordion'} style={{maxHeight: `${accordionHeight}px`}}>
                <div className={'checkbox-accordion__content'} ref={ref}>
                    {children}
                </div>
            </div>
            {renderButton && (
                <div className={'checkbox-accordion__button'}>
                    <button onClick={() => handleClick()}>
                        <span>{buttonText}</span>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.667 8" style={{transform: `rotate(${isOpen ? '180deg' : '0deg'})`}}>
                            <path d="M.667 0a.665.665 0 0 1 .471.2l6.2 6.2 6.2-6.2a.667.667 0 1 1 .943.943L7.805 7.8a.666.666 0 0 1-.943 0L.195 1.133A.667.667 0 0 1 .667 0Z"/>
                        </svg>
                    </button>
                </div>
            )}
        </div>
    )
}

CheckboxAccordion.propTypes = {
    showText: PropTypes.string,
    hideText: PropTypes.string,
    height: PropTypes.number
}